import { render, staticRenderFns } from "./WalletCurrencies.vue?vue&type=template&id=2c53ad5a&scoped=true&"
import script from "./WalletCurrencies.vue?vue&type=script&lang=js&"
export * from "./WalletCurrencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c53ad5a",
  null
  
)

export default component.exports